import React from 'react'
import { OutlinedTextFieldProps, TextField, Typography } from '@mui/material'
import tw from 'twin.macro'
import MaskedInput from 'react-text-mask'
import { RiskMinor } from '@shopify/polaris-icons'

const MaskedInputComponent = MaskedInput as unknown as React.ComponentType<any>

const TextMaskCustom = React.forwardRef<HTMLInputElement, any>(function TextMaskCustom(
  { mask, ...props },
  ref,
) {
  return <MaskedInputComponent {...props} mask={mask} guide={false} inputRef={ref} />
})

export interface BasicTextFieldProps<T>
  extends Omit<OutlinedTextFieldProps, 'name' | 'variant' | 'label'> {
  name: keyof T
  label?: string
  mask?: Array<string | RegExp>
}

export const BasicTextField = <T extends unknown>({
  name,
  type,
  label,
  css,
  mask,
  error,
  helperText,
  inputProps,
  ...rest
}: BasicTextFieldProps<T>) => {
  return (
    <div css={css}>
      <Typography css={tw`mb-1 text-shades-400`} variant="h6">
        {label}
      </Typography>
      <TextField
        name={name as string}
        type={type}
        variant="outlined"
        fullWidth
        placeholder={label}
        error={error}
        helperText={
          !!error &&
          !!helperText && (
            <div css={tw`flex items-start gap-1`}>
              <RiskMinor width={20} css={tw`fill-critical-500 flex-shrink-0 mt-0.5`} />
              <Typography variant="body2" css={tw`text-critical-500`}>
                {helperText}
              </Typography>
            </div>
          )
        }
        FormHelperTextProps={{
          sx: { ml: 0 },
        }}
        {...rest}
        InputProps={{
          ...(mask ? { inputComponent: TextMaskCustom as any } : {}),
          ...rest.InputProps,
        }}
        inputProps={{
          ...(mask ? { mask } : {}),
          ...inputProps,
        }}
      />
    </div>
  )
}
